import React from 'react';
import { BedIcon, ClipboardListIcon, LockIcon, MicroscopeIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Card, CardBody } from '../Card';
import { CtaButton } from '../CtaButton';
const STEPS = [{
  icon: ClipboardListIcon,
  day: 'Day 1',
  title: '3D Facial Design',
  body: 'Arrival, clinical records, CBCT, intraoral scan, and smile design mapped to your own face. Before any surgery, you know exactly how it will look. No surprises.'
}, {
  icon: MicroscopeIcon,
  day: 'Day 2',
  title: 'Guided Surgery Under Sedation',
  body: 'The Dadeland clinical team places four to six premium implants with a printed surgical guide, never freehand. You leave with an esthetic provisional smile for the rest of your trip.'
}, {
  icon: BedIcon,
  day: 'Days 3 and 4',
  title: 'Accompanied Recovery',
  body: 'You rest, attend post procedure checkups, and receive initial adjustments. Your hotel is ten minutes from Dadeland, and the clinical team calls daily to monitor your progress.'
}, {
  icon: SparklesIcon,
  day: 'Day 5',
  title: 'Your Final Zirconia Prosthesis',
  body: "You receive your final zirconia bridge with a custom esthetic micro layer. Its translucency, texture, and shade are matched to your facial anatomy. Then you fly home...smiling."
}];
export function Mechanism() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-113" data-mp="26ora40pro85l">
      <div className="mx-auto max-w-6xl px-6" data-id="element-114" data-mp="2bqqbj51y4uzw">
        <SectionHeading eyebrow="Exactly what happens in those five days" title={<><span data-id="element-116" data-mp="2gngsrvphlwmw">This is not &ldquo;teeth in a day.&rdquo; </span><span className="text-[#1F6E7B]" data-id="element-117" data-mp="2lg040m0pcfoj">It is your final smile in 5 days.</span></>} data-id="element-115" data-mp="2bnudlgq3m6bg">
          <p data-id="element-118" data-mp="2phbxj2mp5l20">Pler Smile Dadeland built a four step protocol that price driven clinics and speed driven clinics cannot replicate.</p>
        </SectionHeading>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-119" data-mp="2uhzr9w2b8fzx">
          {STEPS.map((step, i) => {
          const Icon = step.icon;
          return <Card key={step.day} className="h-full" data-id="element-120" data-mp="zcqhi2pjmm06" data-mpi={i}>
                <CardBody className="flex h-full flex-col" data-id="element-121" data-mp="zb76aqiqv159">
                  <div className="mb-5 flex items-center justify-between" data-id="element-122" data-mp="uf8cgnencqxg">
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#A9DFE9]/40 text-[#1F6E7B]" data-id="element-123" data-mp="193l97mlk6dt0"><Icon size={24} data-id="element-124" data-mp="14buwj9z5fdyf" /></span>
                    <span className="text-sm font-bold uppercase tracking-wide text-[#26B3CA]" data-id="element-125" data-mp="14b1w0qqs9koq">Step {i + 1}</span>
                  </div>
                  <div className="text-sm font-semibold uppercase tracking-wide text-[#1A1A2E]/60" data-id="element-126" data-mp="1e2fztaprp6no">{step.day}</div>
                  <h3 className="mt-1 text-xl font-bold text-[#1A1A2E]" data-id="element-127" data-mp="1s2gxyiendzzg">{step.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#1A1A2E]/80" data-id="element-128" data-mp="1n3461j8x62q0">{step.body}</p>
                </CardBody>
              </Card>;
        })}
        </div>

        <figure className="mx-auto mt-16 max-w-3xl text-center" data-id="element-129" data-mp="3tveqed4iiqjv">
          <blockquote className="text-2xl font-bold leading-snug text-[#1A1A2E] md:text-3xl" data-id="element-130" data-mp="3ovit0wqblxda">
            “We offers the only smile that actually belongs on your face.”
          </blockquote>
        </figure>

        <div className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl bg-[#A9DFE9]/25 p-6 text-[15px] leading-relaxed text-[#1A1A2E]/85" data-id="element-131" data-mp="29aqcydw5vsbo">
          <LockIcon size={20} className="mt-0.5 shrink-0 text-[#1F6E7B]" data-id="element-132" data-mp="1zl6p0ttld89y" />
          <p data-id="element-133" data-mp="1zj3tju9o6mxu">
            Only <span className="font-semibold text-[#1A1A2E]" data-id="element-134" data-mp="1llynvvdvbq34">10 new cases per month</span> access the
            <span className="font-semibold text-[#1A1A2E]" data-id="element-135" data-mp="1qkifabb8du2v"> 5-Day Smile Experience Program</span> in Dadeland.
            This limit is clinical, not commercial. Every case requires exclusive booking of the surgical team.
          </p>
        </div>

        <div className="mt-9 flex flex-col items-center" data-id="element-136" data-mp="1gn47f03didm6">
          <CtaButton label="Reserve My Free Consultation" data-id="element-137" data-mp="3610qjx5ua9x3" />
          <p className="mt-3 text-sm font-medium text-[#1A1A2E]/70" data-id="element-138" data-mp="35zfrbu8ky2sw">You can confirm eligibility before traveling.</p>
        </div>
      </div>
    </section>;
}